export class SessionRequest {
    clientId?: string;
    returnUrl?: string;
    token?: string;
}
